module.exports = __webpack_public_path__ + "static/media/43.6fee7fa2.jpg";